import { useQuery } from 'react-query';

import { getEmployerCostSettings } from 'RestAPIs/admin';

export const useGetTableData = () => {
  const { data, isFetching } = useQuery(
    ['EmployerCostSettings', 'list'],
    async () => {
      const { data } = await getEmployerCostSettings();
      return data;
    }
  );

  return { data, isFetching };
};
